export var StatusBadgeState;
(function (StatusBadgeState) {
    StatusBadgeState["idle"] = "idle";
    StatusBadgeState["pending"] = "pending";
    StatusBadgeState["completed"] = "completed";
    StatusBadgeState["failed"] = "failed";
})(StatusBadgeState || (StatusBadgeState = {}));
